<template>
  <div class="dashboard-page">
    <div class="head">
      <span class="label">{{ $t(`${i18nPrefix}.label.information`) }}</span>
    </div>
    <div class="personal-content">
      <div class="head-info">
        <el-avatar class="photo" :src="$DjangoMediaUrl(personalInfo.photo) || '/static/images_en/default.jpg'"></el-avatar>
        <div class="profile-info">
          <div class="name">{{ personalInfo.name }} (ID: {{ personalInfo.id }})</div>
          <el-tooltip v-if="personalInfo.personal_statement" effect="light" popper-class="light-tooltip-popper dashboard-popper" :content="personalInfo.personal_statement">
            <span class="description">{{ personalInfo.personal_statement }}</span>
          </el-tooltip>
        </div>
      </div>
      <div v-if="!personalInfo.employee || personalInfo.employee.can_apply_job" class="application-info">
        <ApplicationCard class="card" label-i18n-key="personal.home.label.application" visibleArrow :count="personalInfo.finished_application_count" @click.native="handleAllApplication"/>
        <ApplicationCard class="card" label-i18n-key="personal.home.label.inCompleteApplication" visibleArrow :count="personalInfo.pending_application_count" @click.native="handleIncompleteApplication"/>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationCard from '../referrals/dashboard/infoCard.vue'
export default {
  components: {
    ApplicationCard
  },
  props: {
    personalInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.home'
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
  },
  mounted () {

  },
  methods: {
    handleAllApplication () {
      this.$router.push({ path: '/recruiting/personal/applications/completed', query: this.$route.query })
    },
    handleIncompleteApplication () {
      this.$router.push({ path: '/recruiting/personal/applications/incomplete', query: this.$route.query })
    }
  }
}
</script>

<style lang="scss">
.dashboard-page {
  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .personal-content {
    padding: 24px;
    min-height: calc(100vh - 80px - var(--header-height));
    min-height: calc(100dvh - 80px - var(--header-height));
    background-color: #fff;

    .head-info {
      display: flex;
      padding: 24px;
      height: 138px;
      flex-direction: row;

      .photo {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 90px;
        width: 90px;
      }

      .profile-info {
        margin-left: 20px;

        .name {
          font-size: 16px;
          font-weight: 500;
          color: #242526;
          line-height: 22px;
        }

        .description {
          display: inline-block;
          margin-top: 8px;
          font-size: 14px;
          color: #606266;
          max-height: 60px;
          line-height: 20px;
          white-space: pre-wrap;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .application-info {
      padding: 40px 24px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 310px); // 设置每个网格宽度为310px
      row-gap: 14px;
      column-gap: 18px;
      align-items: center;
      justify-content: space-between;

      .card {
        cursor: pointer;

        &:hover {
          .label {
            .label-text {
              color: #0096cc;
            }

            .label-icon {
              color: #0096cc;
            }
          }
        }
      }
    }
  }
}

.dashboard-popper {
  white-space: pre-wrap;
}
</style>
